/* eslint-disable react/prop-types */
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { CToast, CToastHeader, CToastBody, CToaster, CButton } from '@coreui/react'
import { hideToast } from 'src/redux/slices/toastSlice'

const Toast = () => {
  const dispatch = useDispatch()
  const showToast = useSelector((state) => state.toast.showToast)
  const { title, message, color, action, actionLabel, actionHandler } = useSelector(
    (state) => state.toast.options,
  )
  return (
    <CToaster placement="top-end">
      <CToast visible={showToast} color={color} onClose={() => dispatch(hideToast())}>
        <CToastHeader closeButton>
          <strong className="me-auto">{title}</strong>
        </CToastHeader>
        <CToastBody>{message}</CToastBody>
        {action && (
          <CButton style={{ margin: 15 }} onClick={actionHandler}>
            {actionLabel}
          </CButton>
        )}
      </CToast>
    </CToaster>
  )
}

export default React.memo(Toast)
